import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input: React.FC<InputProps> = ({ className = '', ...props }) => {
  return (
    <input
      className={`w-full p-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:border-blue-500 ${className}`}
      {...props}
    />
  );
};
